import React from 'react'
import { connect } from 'react-redux'
import {
  CREATE_PROJECT_MODAL,
  CREATE_FOLDER_MODAL,
  COPY_SUCCESS_MODAL,
  EDIT_FOLDER_MODAL,
  EDIT_PROJECT_MODAL,
  MOVE_PROJECT_MODAL,
  DELETE_PROJECT_MODAL,
  DELETE_MODAL,
  EXPORT_MODAL,
  GATED_BIBLIOGRAPHY_ON_CITATION_COUNT_MODAL,
  GATED_EXPORT_MODAL,
  GATED_BIBLIOGRAPHY_ON_EXPIRATION_MODAL,
  GATED_IN_TEXT_CITATION_MODAL,
  VALUE_EXCHANGE_MODAL,
  CHANGE_TO_FREE_STYLE_MODAL,
  PLAGIARISM_SCROLL_MODAL,
  REDESIGNED_UNLOCK_MODAL,
  COPY_SUCCESS_INTERSTITIAL_MODAL,
  DISCOUNT_MODAL,
  UNLOCK_ACCOUNT_GATE_MODAL,
  UPGRADE_MODAL,
  NEW_CITATION_LIST_MODAL,
} from '@chegg-wt/core/state/modals/constants'
import { AppState } from '@chegg-wt/core/state'
import { UserClickPayload } from '@chegg-wt/core/state/instrumentation/rio/clickstreamInteractions'
import { userClick } from '@chegg-wt/core/state/instrumentation/actions'
import { modalTypeSelector } from '@chegg-wt/core/state/modals/selectors'
import UCFUnlockModal from '../UCFUnlockModal'
import CopySuccess from './CopySuccess'
import CreateProjectModal from './CreateProjectModal'
import CreateFolderModal from './FolderModal/CreateFolderModal'
import EditFolderModal from './FolderModal/EditFolderModal'
import EditProjectModal from './EditProjectModal'
import MoveProjectModal from './MoveProjectModal'
import DeleteProjectModal from './DeleteProjectModal'
import DeleteModal from './DeleteModal'
import ExportModal from './ExportModal'
import GatedBibliographyOnCitationCountModal from './GatedBibliographyOnCitationCountModal'
import GatedExportModal from './GatedExportModal'
import { ExportTabId } from './ExportModal/types'
import GatedBibliographyOnExpirationModal from './GatedBibliographyOnExpirationModal'
import GatedInTextCitationModal from './GatedInTextCitationModal'
import ValueExchangeModal from './ValueExchangeModal'
import UnlockAccountGateModal from './UnlockAccountGateModal'
import PlagiarismScrollModal from './PlagiarismScrollModal'
import CopySuccessInterstitialModal from './CopySuccessInterstitialModal'
import DiscountModal from './DiscountModal'
import ChangeToFreeStyleModal from './ChangeToFreeStyleModal'
import UCFUpgradeModal from './UCFUpgradeModal'
import NewCitationListModal from './NewCitationListModal'

const modals = (exportTabIds, userClick: Props['userClick']) => ({
  [CREATE_PROJECT_MODAL]: <CreateProjectModal />,
  [CREATE_FOLDER_MODAL]: <CreateFolderModal />,
  [EDIT_FOLDER_MODAL]: <EditFolderModal />,
  [EDIT_PROJECT_MODAL]: <EditProjectModal />,
  [MOVE_PROJECT_MODAL]: <MoveProjectModal />,
  [DELETE_PROJECT_MODAL]: <DeleteProjectModal />,
  [DELETE_MODAL]: <DeleteModal />,
  [EXPORT_MODAL]: <ExportModal exportTabIds={exportTabIds} userClick={userClick} />,
  [COPY_SUCCESS_MODAL]: <CopySuccess />,
  [COPY_SUCCESS_INTERSTITIAL_MODAL]: <CopySuccessInterstitialModal />,
  [GATED_BIBLIOGRAPHY_ON_CITATION_COUNT_MODAL]: <GatedBibliographyOnCitationCountModal />,
  [GATED_EXPORT_MODAL]: <GatedExportModal />,
  [GATED_BIBLIOGRAPHY_ON_EXPIRATION_MODAL]: <GatedBibliographyOnExpirationModal />,
  [GATED_IN_TEXT_CITATION_MODAL]: <GatedInTextCitationModal />,
  [VALUE_EXCHANGE_MODAL]: <ValueExchangeModal />,
  [UNLOCK_ACCOUNT_GATE_MODAL]: <UnlockAccountGateModal />,
  [CHANGE_TO_FREE_STYLE_MODAL]: <ChangeToFreeStyleModal />,
  [PLAGIARISM_SCROLL_MODAL]: <PlagiarismScrollModal />,
  [REDESIGNED_UNLOCK_MODAL]: <UCFUnlockModal />,
  [DISCOUNT_MODAL]: <DiscountModal />,
  [UPGRADE_MODAL]: <UCFUpgradeModal />,
  [NEW_CITATION_LIST_MODAL]: <NewCitationListModal />,
})

interface Props {
  modalType: keyof typeof modals
  exportTabIds?: ExportTabId[]
  userClick: (payload: UserClickPayload) => void
}

const GlobalModal = ({ modalType, exportTabIds, userClick }: Props) =>
  modals(exportTabIds, userClick)[modalType] || null

const mapStateToProps = (state: AppState) => ({
  modalType: modalTypeSelector(state),
})

const mapDispatchToProps = {
  userClick,
}

export default connect(mapStateToProps, mapDispatchToProps)(GlobalModal)
